import { useAuth } from '@/app/auth';
import { usePrefs } from '@/app/prefs';
import { Button, Modal } from '@/components/ui';

/**
 * Blocking popup shown the moment a request reveals the session is gone —
 * idle timeout (admin-configurable, Settings → System) or an admin ending it
 * directly. `RequireAuth` already redirects to `/login` on the same signal;
 * this makes that redirect visible instead of silent (docs/spec.md §14
 * round 3, E12).
 */
export function SessionExpiredModal() {
  const { sessionExpired, acknowledgeSessionExpired } = useAuth();
  const { t } = usePrefs();

  return (
    <Modal
      open={sessionExpired}
      title={t.settingsPage.sessionExpiredTitle}
      onClose={acknowledgeSessionExpired}
      actions={
        <Button variant="primary" onClick={acknowledgeSessionExpired}>
          {t.btn.signIn}
        </Button>
      }
    >
      <p style={{ margin: 0 }}>{t.settingsPage.sessionExpiredBody}</p>
    </Modal>
  );
}
